export default "__VITE_ASSET__DFzT2n$x__"